import React, { createContext, useContext } from 'react';

const UserContext = createContext();
const { Consumer: UserConsumer, Provider } = UserContext;

export function UserProvider({ value, children }) {
  return <Provider value={value} >{children}</Provider>;
};
export default UserContext;

export const useUserContext = () => {
  return useContext(UserContext); 
};

export const AuthUserComponent = ({ allowed, children }) => {
  const { currentUser } = useUserContext();
  return currentUser.role === allowed ? children : null;
};
